import { EyeIconDisable, MultiChoiceIcon } from 'assests/GmsIcons';
import React from 'react';

type BaseFieldProps = {
  title?: string;
  label: string;
  children: React.ReactNode;
  isSelected?: boolean;
  showTitle?: boolean;
  id?: string;
}

const BaseField = ({ title, label, children, isSelected = false, showTitle = true, id}: BaseFieldProps) => {
  const baseId = id || 'base-field';

  return (
    <div
      id={baseId}
      data-testid={baseId}
      className={`tw-px-2 tw-py-2 tw-bg-transparent  ${
        isSelected
          ? ''
          : ''
      }`}
    >
      <div id={`${baseId}-header`} className="tw-flex tw-items-center tw-gap-2 tw-mb-1">
        <MultiChoiceIcon />

        {!showTitle ? <EyeIconDisable /> : null}

        {!showTitle ? (
          <div id={`${baseId}-hidden-title`} className="tw-text-[#172B4D] tw-text-sm tw-font-medium">
            Title
          </div>
        ) : null}

        {showTitle && label && (
          <div id={`${baseId}-label`} className="tw-text-[#172B4D] tw-text-sm tw-font-medium">
            {label}
          </div>
        )}
      </div>

      <div id={`${baseId}-content`} className="tw-w-32">
        {children}
      </div>
    </div>
  );
};

export default BaseField;